import { Button, Title, Text, Stack, Paper } from "@mantine/core";
import { useAuth } from "@canucci/base/auth";
import { filledCtaButtonProps, leftAccentCardProps } from "@canucci/base-mantine/theme";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function AccessDeniedPage({ dark = false }: { dark?: boolean }) {
  const { t } = useTranslation("pages");
  const { logout } = useAuth();
  const navigate = useNavigate();
  const paperProps = dark ? leftAccentCardProps : { bg: "white", radius: "md", shadow: "md" as const };

  const handleChangeUser = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <Stack justify="center" align="center" h="100vh" bg={dark ? "transparent" : "gray.1"}>
      <Paper {...paperProps} p="lg">
        <Stack gap="md" ta="center">
          <Title component="h1" order={1} c={dark ? "var(--text-on-dark)" : undefined}>
            {t("errors.accessDenied.title")}
          </Title>
          <Text c={dark ? "var(--text-on-dark-muted)" : undefined}>{t("errors.accessDenied.message")}</Text>
          <Button {...(dark ? filledCtaButtonProps("primary") : {})} onClick={handleChangeUser}>
            {t("errors.accessDenied.goToLogin")}
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
